//Initialize Foundation
$(document).foundation();

$(function() {
  "use strict";
  
  if ($('.product-images').length > 0) {
  	$('.main-images a').magnificPopup({
        type: 'image',
      	mainClass: 'mfp-with-zoom', // this class is for CSS animation below

        zoom: {
          enabled: true, // By default it's false, so don't forget to enable it

          duration: 300, // duration of the effect, in milliseconds
          easing: 'ease-in-out', // CSS transition easing function

          // The "opener" function should return the element from which popup will be zoomed in
          // and to which popup will be scaled down
          // By defailt it looks for an image tag:
          opener: function(openerElement) {
            // openerElement is the element on which popup was initialized, in this case its <a> tag
            // you don't need to add "opener" option if this code matches your needs, it's defailt one.
            return openerElement.is('img') ? openerElement : openerElement.find('img');
          }
        }
    });
  }
  
  if ($('.shopify-challenge__container').length > 0) {
  	$('.shopify-challenge__container').wrapInner ('<section></section');
    $('.shopify-challenge__button').addClass('button');
    $('.shopify-challenge__container').fadeIn(200);
  }

  window.lazySizesConfig = window.lazySizesConfig || {};
  window.lazySizesConfig.expand = 400;
  lazySizesConfig.loadMode = 1;
  
  if ($('.slideshow-one').length > 0) {
    slideshows.slideshowOne();
  }
  
  if ($('.full-items').length > 0) {
    $('.product-caption').each(function() {
    	var captionHeight = $(this).height()/2+35;
      $(this).css('margin-top', captionHeight*(-1));
    });
  }
  
  var newsletter = {
    init: function() {
      var newsletterForm = $('.subscribe-form');
      var newsletterFormResponse = $('.newsletter-response');;
      var newsletterFormAction = $(newsletterForm).attr('action');
      //console.log('Run');
      $(newsletterForm).ajaxChimp({
        url: newsletterFormAction,
        language: 'custom',
        callback: function(resp){  
          newsletterFormResponse.show();
          //console.log('Done');
        }
      });

      $.ajaxChimp.translations.custom = {
        'submit': 'Submitting...',
          0: 'Thank you for subscribing to our newsletter!',
          1: 'Please enter a value',
          2: 'An email address must contain a single @',
          3: 'The domain portion of the email address is invalid (the portion after the @: )',
          4: 'The username portion of the email address is invalid (the portion before the @: )',
          5: 'This email address looks fake or invalid. Please enter a real email address'
      }
    }
  }

  if($('.mailchimp-newsletter').length > 0) {
    newsletter.init();
  }
  
  addToCart.init();
  addToCart.removeCartProduct();
  mobileCart.init();
  mobileSearch.init();
  stickyHeader.init();
  
  singleProductSliders.init();
  
  if($('.product-form-quantity').length > 0) {
  	quantity.init();
  }
  
  if($('.product-page-section').length > 0) {
  	productPage.init();
  }
  
  // Use Enquire to load and distroy scripts for desktop and mobile
  var e = $(window),
      n = {
          mobileDown: "screen and (max-width: 39.99rem)",
          tabletDown: "screen and (max-width: 59.999rem)",
          desktop: "screen and (min-width: 60rem)"
      };
  window.FastClick.attach(document.body), enquire.register(n.desktop, function() {
      e.stellar({
          verticalScrolling: true,
          verticalOffset: false,
          horizontalScrolling: false,
          responsive: true,
          scrollProperty: "scroll",
          positionProperty: "transform",
          parallaxBackgrounds: true,
          parallaxElements: true,
          hideDistantElements: false
      });
  }).register(n.tabletDown, function() {
      e.stellar("destroy"),
      $("[data-stellar-ratio]").removeAttr("style");
  }).register(n.mobileDown, function() {
  })
  
  if ($('#instafeed').length) {
      var feed = new Instafeed({
          get: 'user',
          userId: 2270218888,
          limit: 12,
          sortBy: 'most-recent',
          accessToken: '2270218888.1677ed0.355cbc2691314e0d9bd547ffa01c6237',
          resolution: 'low_resolution',
          template: '<li><a href="{{link}}" target="_blank"><img src="{{image}}" /></a></li>'
      });
      feed.run();
  }
  
  var $grid = $('.masonry-grid');

  $grid.imagesLoaded( function() {
    $('.masonry-grid').masonry({
      itemSelector: '.product-item'
    });
  });
  
  if ($('.gallery-item').length > 0) {
    $('.gallery-item').magnificPopup({
      type: 'image',
      gallery:{
        enabled:true
      }
    });
  }
  
  Shopify.queryParams = {};
  if (location.search.length) {
   for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
      aKeyValue = aCouples[i].split('=');
      if (aKeyValue.length > 1) {
       Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
      }
    }
  }

  $('.layout-grid').on('change', '#FilterBy, #SortBy', function() {
      var sortVal = $('#SortBy').val();
      var filterVal = $('#FilterBy').val();

      Shopify.queryParams.sort_by = sortVal;
      var sortBy = $.param(Shopify.queryParams);

      if (sortVal && filterVal){
        initFilter(filterVal + '?' + sortBy);
      } else if (sortVal && !filterVal) {
        initFilter('?' + sortBy);
      } else if (!sortVal && filterVal){
        initFilter(filterVal);
      }
  });
  
  $('.layout-list').on('change', '#FilterBy, #SortBy', function() {
      var sortVal = $('#SortBy').val();
      var filterVal = $('#FilterBy').val();

      Shopify.queryParams.sort_by = sortVal;
      var sortBy = $.param(Shopify.queryParams);

      if (sortVal && filterVal){
        initFilterList(filterVal + '?' + sortBy);
      } else if (sortVal && !filterVal) {
        initFilterList('?' + sortBy);
      } else if (!sortVal && filterVal){
        initFilterList(filterVal);
      }
  });
  
  $('.layout-full').on('change', '#FilterBy, #SortBy', function() {
      var sortVal = $('#SortBy').val();
      var filterVal = $('#FilterBy').val();

      Shopify.queryParams.sort_by = sortVal;
      var sortBy = $.param(Shopify.queryParams);

      if (sortVal && filterVal){
        initFilterFull(filterVal + '?' + sortBy);
      } else if (sortVal && !filterVal) {
        initFilterFull('?' + sortBy);
      } else if (!sortVal && filterVal){
        initFilterFull(filterVal);
      }
  });
  
  $('.layout-grid').on('click', '.pagination a', function(e) {
  	e.preventDefault();
    var link = $(this).attr('href');
    initFilter(link);
  });
  
  $('.layout-list').on('click', '.pagination a', function(e) {
  	e.preventDefault();
    var link = $(this).attr('href');
    initFilterList(link);
  });
  
  $('.layout-full').on('click', '.pagination a', function(e) {
  	e.preventDefault();
    var link = $(this).attr('href');
    initFilterFull(link);
  });
  
});


function initFilter(filterURL) {
  $.ajax({
     type: 'GET',
     url: filterURL,
     beforeSend: function() {
        $('.masonry-grid').masonry( 'remove', $('.masonry-grid').find('.product-item'));
     },
     success: function(data) {
       var elements = $(data).find('.product-item');
       var pagination = $(data).find('.pagination');
       var collectionSort = $(data).find('.collection-sort');
       $('.masonry-grid').append( elements ).masonry( 'appended', elements );
       $('.pagination').remove();
       $('.pagination-wrapper').html(pagination);
       $('.collection-sort').remove();
       $('.collection-dropdowns').html(collectionSort);
     },
     error: function(x, t, m) {
      console.log(x);
      console.log(t);
      console.log(m);
      location.replace(location.protocol + '//' + location.host + filterURL);
     },
     dataType: "html"
  })
  .done(function( data ) {
    if ($('.masonry-grid .product-item').length > 0){
      $('.masonry-grid').imagesLoaded( function() {
        $('.masonry-grid').masonry({
          itemSelector: '.product-item'
        });
      });
    }
  });
}

function initFilterList(filterURL) {
  $.ajax({
     type: 'GET',
     url: filterURL,
     beforeSend: function() {
        $('.list-items').html('');
     },
     success: function(data) {
       var elements = $(data).find('.product-list-item');
       var pagination = $(data).find('.pagination');
       var collectionSort = $(data).find('.collection-sort');
       $('.list-items').append( elements );
       $('.pagination').remove();
       $('.pagination-wrapper').html(pagination);
       $('.collection-sort').remove();
       $('.collection-dropdowns').html(collectionSort);
     },
     error: function(x, t, m) {
      console.log(x);
      console.log(t);
      console.log(m);
      location.replace(location.protocol + '//' + location.host + filterURL);
     },
     dataType: "html"
  });
}

function initFilterFull(filterURL) {
  $.ajax({
     type: 'GET',
     url: filterURL,
     beforeSend: function() {
        $('.full-items').html('');
     },
     success: function(data) {
       var elements = $(data).find('.product-full-item');
       var pagination = $(data).find('.pagination');
       var collectionSort = $(data).find('.collection-sort');
       $('.full-items').append( elements );
       $('.pagination').remove();
       $('.pagination-wrapper').html(pagination);
       $('.collection-sort').remove();
       $('.collection-dropdowns').html(collectionSort);
       $('.product-caption').each(function() {
            var captionHeight = $(this).height()/2+35;
          $(this).css('margin-top', captionHeight*(-1));
        });
     },
     error: function(x, t, m) {
      console.log(x);
      console.log(t);
      console.log(m);
      location.replace(location.protocol + '//' + location.host + filterURL);
     },
     dataType: "html"
  });
}



var slideshows = {
  slideshowOne: function() {
      var $slideshow = $('.slideshow-one');
      $slideshow.flickity({
          lazyLoad: 2,
          cellAlign: 'left',
          contain: true,
          
            pageDots: true,
          
          imagesLoaded: true,
          prevNextButtons: false,
          
            
              autoPlay: true,
              autoplay: 4000,
            
          
          adaptiveHeight: true,
          pauseAutoPlayOnHover: true
      });
      var flkty = $slideshow.data('flickity');
      $slideshow.on( 'settle.flickity', function() {
          console.log('Settle');
          if($slideshow.is(':visible')) {
            var currentSlide = flkty.selectedIndex + 1;
            $('.slideshow-one .caption').removeClass('animated fadeInShort');
            $('.slideshow-one .sale-wrapper').removeClass('animated tada').css('opacity', '1');
            $('.slideshow-one .slide:nth-child(' + currentSlide + ') .sale-wrapper').addClass('animated tada').css('opacity', '1');
            $('.slideshow-one .slide:nth-child(' + currentSlide + ') .caption').addClass('animated fadeInShort');
          }
      });

      // previous
      $('.slideshow-one-wrapper .slideshow-nav.previous').on( 'click', function(e) {
          e.preventDefault();
          $slideshow.flickity('previous');
      });
      // next
      $('.slideshow-one-wrapper .slideshow-nav.next').on( 'click', function(e) {
          e.preventDefault();
          $slideshow.flickity('next');
      });
  }
}




/*var $newsletter_form = $('.banner-with-form .contact-form');
$newsletter_form.each(function() {
  var $form = $(this);
  $form.on('submit', function (e) {
    e.preventDefault();
    console.log('Form submitted');
    if($('input[name="challenge"]', $form).val() !== "true") {
      $.ajax({
        type: $form.attr('method'),
        url: $form.attr('action'),
        data: $form.serialize(),
        success: function (data) {
          $form.fadeOut("slow", function(){
            $form.prev('.message').html("Thank you for joining our mailing list!");
          });
        },
        error: function(data) {
          $('input[name="challenge"]', $form).val('true');
          $form.submit();
        }
      });
    }
  });
});*/

var addToCart = {
  init: function() {

    $('body').on('submit', ".product-form", function(e) {
      e.preventDefault();
      var $addToCartForm = $(this);
      var $addToCartBtn = $addToCartForm.find('.add-to-cart');

      $.ajax({
        url: '/cart/add.js',
        dataType: 'json',
        type: 'post',
        data: $addToCartForm.serialize(),
        beforeSend: function() {
          $addToCartBtn.find('i').removeClass('ti-shopping-cart').addClass('ti-reload spin');
        },
        success: function(data) {
          console.log(data);

          $addToCartBtn.find('i').removeClass('ti-reload spin').addClass('ti-check');
          $addToCartBtn.find('.AddToCartText').text('Added to cart');

          setTimeout(function(){
            $addToCartBtn.find('i').removeClass('ti-check').addClass('ti-shopping-cart');
            $addToCartBtn.find('.AddToCartText').text('Add to cart');
          },1500);

          var $productAddedModal = $('.added-to-cart');

          $productAddedModal.find('.product-added').html('<strong>'+data.product_title+'</strong> was successfully added to your cart!');
          $productAddedModal.find('img').attr('src', data.image);
          $productAddedModal.find('img').attr('alt', data.product_title);
          $productAddedModal.find('img').attr('title', data.product_title);
          if(!$('.cart-header-item a span').length > 0) {
              $('.cart-header-item a').append('<span></span>');
          }
          var inst = $('[data-remodal-id=cartModalSuccess]').remodal();
          inst.open();

          $.getJSON("/cart.js", function(cart) {
            refreshCart(cart);
          });
        },
        error: function(XMLHttpRequest) {
          var response = eval('(' + XMLHttpRequest.responseText + ')');
          response = response.description;
          console.log(response);
          $('.error-to-cart .product-error').html(response);
          var inst = $('[data-remodal-id=cartModalError]').remodal();
          inst.open();

          $addToCartBtn.find('i').removeClass('ti-reload spin').addClass('ti-close');
          $addToCartBtn.find('.AddToCartText').text('Error!');

          setTimeout(function(){
            $addToCartBtn.find('i').removeClass('ti-close').addClass('ti-shopping-cart');
            $addToCartBtn.find('.AddToCartText').text('Add to cart');
          },1500);
        }
      });

      return false;
    });

    $('body').on('closed', ".notification-modal", function(e) {
      $('.added-to-cart .product-added').html('');
      $('.added-to-cart img').attr('src', '');
      $('.added-to-cart img').attr('alt', '');
      $('.added-to-cart img').attr('title', '');
    });

  },
  removeCartProduct: function() {
    $('body').on('click', '.remove-header-cart-product, .cart-item-remove', function(e) {
      e.preventDefault();
      var lineID = $(this).data('line-id');
      removeCartLine(lineID);
    });
  }
}

var mobileCart = {
  init: function() {
    $('.cart-header-item.mobile').on('click', 'a', function(e) {
      e.preventDefault();
      $('.mobile-cart-container').toggle();
      $(this).parent('.cart-header-item.mobile').toggleClass('open');
      $('.mobile-search-container').hide();
      $('.search-header-item.mobile').removeClass('open');
    });
  }
}

var mobileSearch = {
  init: function() {
    $('.search-header-item.mobile').on('click', 'a', function(e) {
      e.preventDefault();
      $('.mobile-search-container').toggle();
      $(this).parent('.search-header-item.mobile').toggleClass('open');
      $('.mobile-cart-container').hide();
      $('.cart-header-item.mobile').removeClass('open');
    });
  }
}

var stickyHeader = {
  init: function() {
    if ($(window).width() > 768) {
      var sticky_nav = new Headhesive('.store-header', {
        offset: 700,
        throttle: 300,
        classes: {
          clone: 'sticky-nav',
          stick: 'sticky-nav-stuck',
          unstick: 'sticky-nav-unstuck'
        },
        onInit: function() {
        },
        onUnstick: function() {
        }
      });
    }
  }
}

/*var zoomThis = {
    init: function(selectorParent) {
        $(selectorParent).each(function() {
            var large_img = $(this).find('img').data('zoom');
            $(this).find('img').wrap('<span style="display:block"></span>')
            .css('display', 'block')
            .parent()
            .zoom({
                url: large_img,
                touch: false,
                on: 'mouseover',
                duration: 200
            });
        });
    }
}*/

var quantity = {
  init: function() {
  	$('body').on('click', '.js-change-quantity', function() {
        var $this = $(this),
            $input = $(this).siblings('input'),
            val = parseInt($input.val()),
            valMax = 1000000000000000,
            valMin = $input.attr('min') || 0;

        if ($input.attr('max') != null){
          valMax = $input.attr('max');
        }

        if(isNaN(val) || val < valMin) {
            $input.val(valMin);
            return false;
        } else if (val > valMax) {
            $input.val(valMax);
            return false;
        }

        if($this.data('direction') == 'plus') {
            if(val < valMax) $input.val(val + 1);
        } else {
            if(val > valMin) $input.val(val - 1);
        }
        $input.trigger('change');
    });
    
    $('body').on('change', '.cart-page-js-update-quantity', function() {
      var qty = parseInt($(this).val());
      var lineID = $(this).data('line-id');
      refreshLineQuantity(qty, lineID);
    });
  }
}

function refreshLineQuantity(qty, lineID) {
  $.ajax({
    url: '/cart/change.js',
    dataType: 'json',
    type: 'post',
    data: { quantity: qty, line: lineID },
    success: function (data) {
      refreshCart(data, lineID);
    },
    error: function(response) {
    	console.log(response);
    }
  });
}


var singleProductSliders = {
    init: function() {
      
      $('.main-images').flickity({
          // options
          lazyLoad: 2,
          cellAlign: 'left',
          "arrowShape": { 
            x0: 10,
            x1: 60, y1: 50,
            x2: 65, y2: 45,
            x3: 20
          },
          contain: true,
          imagesLoaded: true,
          adaptiveHeight: true,
          dragThreshold: 10,
          selectedAttraction: 0.01,
          friction: 0.15,
          pageDots: false
      });
      $('.secondary-images').flickity({
          // options
          lazyLoad: 2,
          cellAlign: 'left',
          contain: true,
          imagesLoaded: true,
          adaptiveHeight: true,
          dragThreshold: 10,
          selectedAttraction: 0.01,
          friction: 0.15,
          pageDots: false,
          asNavFor: '.main-images',
          prevNextButtons: false
      });

      /*var to_Zoom = $('.main-images .slide');
      zoomThis.init(to_Zoom);*/
     
    }
}

function refreshCart(cart, lineID) {
  console.log(cart);
  var cart_items_html = "";
  var cart_page_items_html = "";
  var $cartDrop = $('.cart-dropdown');
  $cartDrop.html('');
  
  if (cart.item_count == 0) {
    cart_items_html += '<li class="cart-item-header">Your cart is empty</li>';
    $('.cart-header-item > a > span').remove();
    $('form.cart-form').remove();
    $('.show-empty-cart-on-js').show();
  } else {
    cart_items_html += '<li class="cart-item-header">Your cart</li>';
  	$.each(cart.items, function(index, item) {
      console.log(item);
      //For cart dropdown
      var lineID = index + 1;
      
      cart_items_html += '<li class="cart-item">';
      if (item.image) {
        cart_items_html += '<a class="image-link" href="'+ item.url +'">' +
          '<img src="' + item.image.replace(/(\.[^.]*)$/, "_compact$1").replace('http:', '') + '" alt="' + encodeHtml(item.title) + '" />' +
          '</a>';
      }
      cart_items_html += '<div class="product-details">'+
        '<h4><a href="'+ item.url +'">'+ item.title +'</a></h4>'+
        '<p>' + Shopify.formatMoney(item.price, $cartDrop.data('money-format')) + '</p>'+
        '<p>Q-ty: <strong>'+ item.quantity +'</strong></p>'+
        '<a class="remove-header-cart-product" data-line-id="'+ lineID +'" href="/cart/change?line='+ lineID +'&amp;quantity=0"><i class="ti-close"></i></a>'+
        '</li>';
      
      //For cart page
      cart_page_items_html += '<div class="line-'+lineID+' cart-line" id="">';
        cart_page_items_html += '<div class="row">';
          cart_page_items_html += '<div class="small-12 medium-4 columns">';
            cart_page_items_html += '<a href="'+item.url+'">';
      			cart_page_items_html +='<img src="' + item.image.replace(/(\.[^.]*)$/, "_100x$1").replace('http:', '') + '" data-srcset="' + item.image.replace(/(\.[^.]*)$/, "_100x$1").replace('http:', '') + ' 100w, ' + item.image.replace(/(\.[^.]*)$/, "_300x$1").replace('http:', '') + ' 300w, ' + item.image.replace(/(\.[^.]*)$/, "_400x$1").replace('http:', '') + ' 400w, ' + item.image.replace(/(\.[^.]*)$/, "_600x$1").replace('http:', '') + ' 600w, ' + item.image.replace(/(\.[^.]*)$/, "_800x$1").replace('http:', '') + ' 800w, ' + item.image.replace(/(\.[^.]*)$/, "_1000x$1").replace('http:', '') + ' 1000w, ' + item.image.replace(/(\.[^.]*)$/, "_1200x$1").replace('http:', '') + ' 1200w, ' + item.image.replace(/(\.[^.]*)$/, "_1400x$1").replace('http:', '') + ' 1400w" data-src="' + item.image.replace(/(\.[^.]*)$/, "_100x$1").replace('http:', '') + ' 100w" sizes="auto" class="lazyload lazyautosizes blur-up" alt="' + encodeHtml(item.title) + '">';
            cart_page_items_html += '</a>';//a
          cart_page_items_html += '</div>';//small-12 medium-4 columns
          cart_page_items_html += '<div class="small-12 medium-8 columns">';
      		cart_page_items_html +='<h4><a href="'+item.url+'">'+item.product_title+'</a></h4>';
      		if (item.variant_title != null) {
      			cart_page_items_html +='<p><small>'+item.variant_title+'</small></p>';
      		}
            if (item.price != item.original_price) {
				cart_page_items_html +='<p class="cart-item-price-container"><span class="cart-item-price">'+Shopify.formatMoney(item.price, $cartDrop.data('money-format'))+'</span><s class="cart-item-original-price">'+Shopify.formatMoney(original_price, $cartDrop.data('money-format'))+'</s></p>';
            } else {
            	cart_page_items_html +='<p class="cart-item-price-container"><span class="cart-item-price">'+Shopify.formatMoney(item.price, $cartDrop.data('money-format'))+'</span><s class="cart-item-original-price"></s></p>';
            }
            cart_page_items_html +='<div class="product-form-quantity"><span class="product-minus js-change-quantity" data-direction="minus"><span class="ti-minus"></span></span><input type="number" min="1" size="2" class="quantity cart-page-js-update-quantity" data-line-id="'+ lineID +'" name="updates['+item.key+']" id="quantity" value="'+item.quantity+'"><span class="product-plus js-change-quantity" data-direction="plus"><span class="ti-plus"></span></span></div>';
            cart_page_items_html +='<a href="/cart/change?line='+lineID+'&amp;quantity=0" class="cart-item-remove" data-line-id="'+lineID+'"><span class="ti-close"></span></a>';
          cart_page_items_html += '</div>';//small-12 medium-8 columns
        cart_page_items_html += '</div>';//row
      cart_page_items_html += '</div>';//cart-line
    });
    
    cart_items_html += '<li class="cart-item-footer"><p>TOTAL: <strong>' + Shopify.formatMoney(cart.total_price, $cartDrop.data('money-format')) + '</strong></p><a href="/cart" class="button">View cart <i class="ti-arrow-right"></i></a></li>';
	
    if ($('.cart-page').length > 0) {
    	$('#cart-line-items-container').html(cart_page_items_html);
        $('.cart-page-subtotal .cart-subtotal').html(Shopify.formatMoney(cart.total_price, $cartDrop.data('money-format')));
        $('.cart-line').last().addClass('last');
    }
  }
  
  $cartDrop.html(cart_items_html);
  
  /*if ($('.cart-page').length > 0) {
  	$('.line-'+lineID).remove();
    $('.cart-page-subtotal .cart-subtotal').html(Shopify.formatMoney(cart.total_price, $cartDrop.data('money-format')));
    if($('.cart-line').length == 0) {
    	$('.cart-actions').remove();
        $('.show-empty-cart-on-js').show();
    }
  }*/
}

function removeCartLine(lineID) {
  $.ajax({
    url: '/cart/change.js',
    dataType: 'json',
    type: 'post',
    data: { quantity: 0, line: lineID },
    success: function (data) {
      refreshCart(data, lineID);
    }
  });
}

function encodeHtml(value){
    if (value) {
        return $('<div/>').text(value).html();
    } else {
        return '';
    }
}

var productPage = {
  init: function() {
    new Shopify.OptionSelectors($(".product-form").data('select'), { product: $(".product-form").data('product'), onVariantSelected: selectCallback, enableHistoryState: false });
  }
}

selectCallback = function(variant, selector) {
  var $product = $('.product-' + selector.product.id);
  var $productForm = $('form.product-form', $product);
  var variantID = variant.id;
                       
  if (variant && variant.available == true) {
    var $mainSlider = $product.find('.main-images');
    $mainSlider.flickity( 'selectCell', '.slide-'+variantID );
    
    if(variant.price < variant.compare_at_price){
      $('.old-price', $product).html(Shopify.formatMoney(variant.compare_at_price, $productForm.data('money-format')));
    } else {
      $('.old-price', $product).html('')
    }
    
    if (variant.price > 0) {
      $('.current-price', $product).html(Shopify.formatMoney(variant.price, $productForm.data('money-format')));
    } else {
      $('.current-price', $product).html("Free");
    }
    
    $('.add-to-cart', $product).removeClass('disabled').removeAttr('disabled');
  } else {
  	var message = variant ? "Sold Out" : "Unavailable";
    $('.old-price', $product).text('');
    $('.current-price', $product).text(message);
    $('.add-to-cart', $product).addClass('disabled').attr('disabled', 'disabled');
  }
};

